import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DetailPopupModule } from '@iot-platform/iot-platform-ui';
import { Asset } from '@iot-platform/models/i4b';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { StatusChipComponent } from '../status-chip/status-chip.component';

@Component({
  imports: [FlexLayoutModule, InfoDisplayPipe, TranslatePipe, DetailPopupModule, StatusChipComponent],
  selector: 'iot4bos-ui-asset-basic-info',
  templateUrl: './basic-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasicInfoComponent {
  asset = input.required<Asset>();
  displayMode = input<'vertical' | 'horizontal' | 'default'>('default');

  selectAsset = output<Asset>();
}
